import React, {Component} from "react";
import PageTitle from "../Components/Theme/PageTitle/index.js";
import DashboardLayout from "../Components/Theme/DashboardLayout/index.js";


export default class ToursOffered extends Component {

    render() {
        return (
            <DashboardLayout>
                {/*** Page Title ***/}
                <PageTitle title={'View / Accept Tours Offered'}
                           subTitle={''}/>

            </DashboardLayout>
        )
    }
}
